module.exports = "<p>\r\n  resources-planning works!\r\n</p>\r\n"